export const EMPTY_ANNOTATION_TAG = {
  tag: "",
  color: "",
  description: "",
};

export const SAMPLE_TEXT = "Lorem ipsum dolor sit amet";
